export default __webpack_public_path__ + "img/78212a2ce073b0c32a77f5a10a6adaf5.png";